import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { EmailStatsDashboard } from "@/components/admin/email/EmailStatsDashboard";

export const Route = createFileRoute("/_authenticated/admin/email/stats")({
  head: () => ({
    meta: [
      { title: "Админ — Имейл · Статистика | FIXHEN" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <AdminLayout>
      <EmailStatsDashboard />
    </AdminLayout>
  ),
});
